exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.fa-spin[data-v-657643b3] {\n  font-size: 40px;\n}\n.table thead tr th[data-v-657643b3] {\n  position: sticky;\n  top: 59px;\n}\n", ""]);

// exports
